export default __webpack_public_path__ + "04a30e787d1f9577b1a815996eb6c934.png";